@import '_base.css';

:root {
  --spw-ds-primary: var(--spw-color-themes-blue-blue-500);
  --spw-ds-variant: var(--spw-color-themes-blue-blue-700);
  --spw-ds-active: var(--spw-color-themes-blue-blue-800);
  --spw-ds-cta-outlined-bg-hover: var(--spw-color-themes-blue-blue-50);
  --spw-ds-cta-outlined-stroke-hover: var(--spw-color-themes-blue-blue-700);
  --spw-ds-cta-outlined-bg-active: var(--spw-color-themes-blue-blue-100);
  --spw-ds-cta-outlined-stroke-active: var(--spw-color-themes-blue-blue-800);
}
